"use strict";
import i from "./index.es144.js";
import f from "./index.es145.js";
import e from "./index.es146.js";
import p from "./index.es147.js";
import s from "./index.es148.js";
import l from "./index.es149.js";
import u from "./index.es150.js";
import c from "./index.es151.js";
import d from "./index.es152.js";
import { VERSION as x } from "./index.es153.js";
import C from "./index.es154.js";
import A from "./index.es155.js";
import E from "./index.es156.js";
import g from "./index.es157.js";
import w from "./index.es158.js";
import O from "./index.es159.js";
import y from "./index.es160.js";
function n(o) {
  const m = new e(o), t = f(e.prototype.request, m);
  return i.extend(t, e.prototype, m, { allOwnKeys: !0 }), i.extend(t, m, null, { allOwnKeys: !0 }), t.create = function(a) {
    return n(p(o, a));
  }, t;
}
const r = n(s);
r.Axios = e;
r.CanceledError = u;
r.CancelToken = c;
r.isCancel = d;
r.VERSION = x;
r.toFormData = C;
r.AxiosError = A;
r.Cancel = r.CanceledError;
r.all = function(o) {
  return Promise.all(o);
};
r.spread = E;
r.isAxiosError = g;
r.mergeConfig = p;
r.AxiosHeaders = w;
r.formToJSON = (o) => l(i.isHTMLForm(o) ? new FormData(o) : o);
r.getAdapter = O.getAdapter;
r.HttpStatusCode = y;
r.default = r;
export {
  r as default
};
//# sourceMappingURL=index.es84.js.map
